import { useEffect } from 'react';
import { SellingOffersProductsItem } from '@interfaces/models/negotiation/domain/SellingOffersProduct';
import { ProductItemListCard } from '@components/organisms/selling-offers/product-item-list-card/product-item-list-card';
import { useListItemSelectContext } from '@context/negotiation-listings-split-view.context';

interface SellingOffersProductListProps {
  productsList: SellingOffersProductsItem[];
}

const SellingOffersProductsList: React.FC<SellingOffersProductListProps> = ({ productsList }) => {
  const { handleItemClick, setListData, selectedListItemId } = useListItemSelectContext();

  useEffect(() => {
    setListData(productsList);
  }, [productsList]);

  return (
    <>
      <ul>
        {productsList.map((item) => (
          <ProductItemListCard
            key={item.product.id}
            productData={item}
            isSelected={selectedListItemId === item.product.id}
            onClick={() => {
              handleItemClick(item.product.id);
            }}
          />
        ))}
      </ul>
    </>
  );
};

export default SellingOffersProductsList;
